var _ellipse, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuarantee({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.1251,
    cy: 25,
    rx: 25.0582,
    ry: 25,
    fill: "#1ABC9C",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0748 15.2941H30.6675",
    stroke: "#1ABC9C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0748 19.7059H30.6675",
    stroke: "#1ABC9C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0748 24.1177H30.6675",
    stroke: "#1ABC9C",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0748 28.5294H25.8033",
    stroke: "#1ABC9C",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0748 32.9412H22.2656",
    stroke: "#1ABC9C",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.0948,
    y: 11,
    width: 20.5524,
    height: 28,
    rx: 1,
    stroke: "#1ABC9C",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.118 32.719L28.2203 31.9943C28.252 31.7697 28.3592 31.5625 28.5242 31.4069L40.0108 20.5699C40.5929 20.0207 41.5015 20.018 42.087 20.5637C42.716 21.1499 42.7329 22.141 42.1243 22.7482L36.8707 27.9896L30.457 33.6774C30.2476 33.8631 29.97 33.9525 29.6916 33.924L29.0063 33.8537C28.4419 33.7959 28.0386 33.2807 28.118 32.719Z",
    fill: "#1ABC9C",
    fillOpacity: 0.25,
    stroke: "#1ABC9C",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0624 21.5688L40.7327 23.2352",
    stroke: "#1ABC9C",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8767 25V25C41.5778 25.7773 41.5148 26.9744 40.7359 27.6737L37.7653 30.341",
    stroke: "#1ABC9C",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuarantee);
export default __webpack_public_path__ + "static/media/guarantee.17ae646e2b7656fb2e3338beaea3c751.svg";
export { ForwardRef as ReactComponent };